import LeafletTitle from './Index.vue'

LeafletTitle.install = function(Vue) {
  Vue.component(LeafletTitle.name, LeafletTitle)
}

export default LeafletTitle
